import { useState } from 'react'
import { Formik } from 'formik'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { getApiErrorMessage, logApiError } from 'services/apiError'
import NumberInput from 'components/Inputs/NumberInput'
import MoneyInput from 'components/Inputs/MoneyInput'
import Select from 'components/Inputs/Select'
import MainButton from 'components/Buttons/MainButton'
import billProductValidator from 'validators/billProductValidator'
import { FaTimes } from 'react-icons/fa'

import {
  Form,
  FormField,
  CloseButton,
  FieldGrid,
  Row,
  InfoText,
  Label,
  WarningText,
  ErrorContainer
} from './styles'

export default function BillProductForm ({
  bill,
  products = [],
  professionals = [],
  onConfirm: handleConfirm,
  onClose: handleClose
}) {
  const [errorMessage, setErrorMessage] = useState (null)
  const token = AuthService.getToken ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  const handleProductSelected = async (name, option, setFieldValue) => {
    const product = option.value

    setFieldValue ('custom_price', product.price)
    setFieldValue ('custom_comission_percentage', product.comission_percentage * 100)
    setFieldValue (name, option)
  }

  return (
    <Formik
      validationSchema={billProductValidator}
      initialValues={{
        'product': null,
        'professional': null,
        'amount': 1,
        'custom_price': 0,
        'custom_comission_percentage': 0
      }}
      onSubmit={async (values, { setSubmitting }) => {
        const productData = {
          product_id: values.product.value.id,
          professional_id: values.professional?.value || null,
          amount: values.amount,
          custom_price: values.custom_price,
          custom_comission_percentage: values.custom_comission_percentage / 100
        }

        try {
          const { data: product } = await cutileiApi.post (
            `/business_bills/${bill.id}/products`, productData, requestConfig
          )

          setSubmitting (false)
          handleConfirm (product)
          handleClose ()
        } catch (error) {
          setSubmitting (false)
          setErrorMessage (getApiErrorMessage (error))
          logApiError (error)
        }
      }}
    >
      {({
        values,
        errors,
        touched,
        isSubmitting,
        setFieldValue,
        setFieldTouched,
        handleBlur,
        handleSubmit
      }) => (
        <Form>
          <FieldGrid>
            <FormField>
              {touched.product && errors.product && (
                <WarningText>
                  {errors.product}
                </WarningText>
              )}
              <Select
                name='product'
                placeholder='Produto...'
                value={values.product}
                options={products.map (product => ({
                  label: product.name, value: product
                }))}
                onChange={(name, option) => handleProductSelected (name, option, setFieldValue)}
                onBlur={setFieldTouched}
                error={errors.product}
                touched={touched.product}
              />             
            </FormField>
            <FormField>
              <Select
                name='professional'
                placeholder='Profissional...'
                value={values.professional}
                options={professionals.map (professional => ({
                  label: professional.nickname, value: professional.id
                }))}
                onChange={setFieldValue}
                onBlur={setFieldTouched}
                error={errors.professional}
                touched={touched.professional}
              />
            </FormField>
            <FormField>
              <Label htmlFor='product_amount'>
                Qtd
              </Label>
              <NumberInput
                id='product_amount'
                name='amount'
                value={values.amount}
                minValue={1}
                maxValue={99}
                onChange={(name, value) => {
                  setFieldValue ('custom_price', (values.product?.value.price ?? 0) * value)
                  setFieldValue (name, value)
                }}
                style={{width: '100%'}}
              />
            </FormField>
            <FormField>
              <Label htmlFor='product_price'>
                Preço
              </Label>
              <MoneyInput
                id='product_price'
                name='custom_price'
                placeholder='Valor'
                value={values.custom_price}
                onValueChange={setFieldValue}
                onBlur={handleBlur ('custom_price')}
              />
            </FormField>
            <FormField>
              <Label htmlFor='product_comission_percentage'>
                Comissão (%)
              </Label>
              <NumberInput
                id='product_comission_percentage'
                name='custom_comission_percentage'
                value={values.custom_comission_percentage}
                minValue={0}
                maxValue={100}
                onChange={setFieldValue}
                style={{width: '100%'}}
              />
            </FormField>
            <MainButton
              label='Adicionar'
              onClick={handleSubmit}
              disabled={isSubmitting}
              loading={isSubmitting}
              width={110}
            />
            <CloseButton onClick={handleClose}>
              <FaTimes color='#FF3939' size={18}/>
            </CloseButton>
          </FieldGrid>
          <Row>
            {errorMessage && (
              <ErrorContainer>
                <InfoText>{errorMessage}</InfoText>
              </ErrorContainer>
            )}
          </Row>
        </Form>
      )}
    </Formik>
  )
}
